var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 503.559 503.559",
    style: {
      enableBackground: "new 0 0 503.559 503.559"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB000"
    },
    d: "M502.659,193.299c-2.4-8-9.6-14.4-18.4-16l-146.4-21.6l-65.6-132c-4-8-12-12.8-20.8-12.8 s-16.8,4.8-20.8,12.8l-65.6,132.8l-145.6,20.8c-8.8,1.6-16,7.2-18.4,16c-2.4,8-0.8,17.6,5.6,24l105.6,103.2l-24.8,145.6 c-1.6,8.8,2.4,17.6,8.8,22.4c7.2,4.8,16.8,5.6,24,1.6l131.2-68.8l130.4,68.8c3.2,1.6,7.2,2.4,10.4,2.4c4.8,0,9.6-1.6,13.6-4 c7.2-4.8,10.4-13.6,8.8-22.4l-24.8-145.6l105.6-103.2C502.659,210.899,505.059,201.299,502.659,193.299z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB000"
    },
    points: "136.259,481.299 136.259,481.299 251.459,421.299 366.659,481.299 366.659,481.299 251.459,366.099  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9D00"
    },
    d: "M502.659,193.299c-2.4-8-9.6-14.4-18.4-16l-146.4-21.6l-65.6-132c-4-8-12-12.8-20.8-12.8 s-16.8,4.8-20.8,12.8l-65.6,132.8l-65.6,9.6l313.6,313.6c2.4-4,3.2-8.8,1.6-13.6l-24.8-145.6l105.6-103.2 C502.659,210.899,505.059,201.299,502.659,193.299z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB000"
    },
    d: "M251.459,10.899c-8,0.8-16,5.6-20,12.8l-65.6,132.8l-146.4,20.8c-8.8,1.6-16,7.2-18.4,16 c-2.4,8-0.8,17.6,5.6,24l105.6,103.2l-24.8,145.6c-1.6,8.8,2.4,17.6,8.8,22.4c7.2,4.8,16.8,5.6,24.8,1.6l130.4-68V10.899z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9D00"
    },
    d: "M231.459,23.699l-65.6,132.8l-64.8,9.6l150.4,149.6v-304.8C243.459,11.699,235.459,16.499,231.459,23.699z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB000"
    },
    points: "137.059,481.299 137.059,481.299 251.459,422.099 251.459,367.699  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating-star.a3af5a27dd797f4a4c16d26ccbff1af7.svg";
export { ForwardRef as ReactComponent };